import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CollectionTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/CollectionTile";
import { CollectionTileImpressionProvider } from "@faire/retailer-visitor-shared/views/product-based-collection/CollectionTileImpressionProvider";
import { Grid } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackApparelCollectionsCollectionDetailsMoreCollectionsCollectionClick } from "@faire/web-api--source/events/apparelCollections/click/collectionDetailsMoreCollectionsCollection";
import { ICollectionTile } from "@faire/web-api--source/indigofair/data/ICollectionTile";
import * as React from "react";
export var OtherProductBasedCollections = function(param) {
    var otherCollections = param.otherCollections, collection = param.collection, columnCount = param.columnCount, gridGap = param.gridGap;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: (collection === null || collection === void 0 ? void 0 : collection.brand_name) ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "qhNw5k",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "More collections by "
                        },
                        {
                            type: 1,
                            value: "brandCompanyName"
                        }
                    ],
                    values: {
                        brandCompanyName: collection === null || collection === void 0 ? void 0 : collection.brand_name
                    }
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "H2KTYn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "More collections"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(CollectionTileImpressionProvider, {
                contextToken: collection === null || collection === void 0 ? void 0 : collection.token,
                requestId: "",
                screenContext: ICollectionTile.Screen.PRODUCT_BASED_COLLECTION,
                containerContext: ICollectionTile.ScreenContainer.MORE_COLLECTIONS,
                children: /*#__PURE__*/ _jsx(Grid, {
                    gap: gridGap,
                    columns: Math.max(2, columnCount),
                    columnTemplate: function(columns) {
                        return "repeat(".concat(columns, ", minmax(0, 232px));");
                    },
                    children: otherCollections.map(function(otherCollection, index) {
                        return /*#__PURE__*/ _jsx(CollectionTile, {
                            collection: otherCollection,
                            onClick: function() {
                                var _otherCollection_collection_promo;
                                var _collection_token, _otherCollection_collection_promo_brand_promo_collection_token;
                                return trackApparelCollectionsCollectionDetailsMoreCollectionsCollectionClick((_collection_token = collection === null || collection === void 0 ? void 0 : collection.token) !== null && _collection_token !== void 0 ? _collection_token : "", otherCollection.product_based_collection_token, (_otherCollection_collection_promo_brand_promo_collection_token = (_otherCollection_collection_promo = otherCollection.collection_promo) === null || _otherCollection_collection_promo === void 0 ? void 0 : _otherCollection_collection_promo.brand_promo_collection_token) !== null && _otherCollection_collection_promo_brand_promo_collection_token !== void 0 ? _otherCollection_collection_promo_brand_promo_collection_token : "");
                            }
                        }, "".concat(otherCollection.product_based_collection_token, "-").concat(index));
                    })
                })
            })
        ]
    });
};
